import { render, staticRenderFns } from "./set-service.vue?vue&type=template&id=6dce1f09&scoped=true&lang=pug&"
import script from "./set-service.vue?vue&type=script&lang=js&"
export * from "./set-service.vue?vue&type=script&lang=js&"
import style0 from "./set-service.vue?vue&type=style&index=0&id=6dce1f09&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dce1f09",
  null
  
)

export default component.exports